module.exports = __webpack_public_path__ + "6a11cfe7ac7c6a97df2d21fd8820e427.svg";